module.exports = __webpack_public_path__ + "img/八方悅鍋物.feb1797d.svg";